import React from 'react';
import { Download, Trash2, Upload, FolderOpen } from 'lucide-react';
import { Button } from '../../components/ui/button';

const DocumentActions = ({ doc, transitions, isExcluded, isAdmin, canEdit, exporting, editMode, onStatusDialog, onEditVars, onExport, onDelete, onUpload, onAlfrescoExport, alfrescoConnected }) => {
  return (
    <div className="bg-white border border-[#E5E5EA] rounded-xl p-4">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-2 flex-wrap">
          {!isExcluded && transitions.map((t) => (
            <Button
              key={t.status}
              onClick={() => onStatusDialog(t)}
              className={`${t.color} text-white`}
              size="sm"
              data-testid={`action-${t.status.toLowerCase().replace(/\s/g, '-')}`}
            >
              <t.icon className="w-4 h-4 mr-1.5" />
              {t.label}
            </Button>
          ))}
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          {canEdit && (
            <Button variant="outline" size="sm" onClick={onEditVars} data-testid="edit-variables-button">
              {editMode ? 'Cancelar Edicao' : 'Editar Variaveis'}
            </Button>
          )}
          <Button variant="outline" size="sm" onClick={() => onExport('docx')} disabled={exporting} data-testid="export-docx-button">
            <Download className="w-4 h-4 mr-1.5" />{exporting ? 'Exportando...' : '.docx'}
          </Button>
          <Button variant="outline" size="sm" onClick={() => onExport('pdf')} disabled={exporting} data-testid="export-pdf-button">
            <Download className="w-4 h-4 mr-1.5" />.pdf
          </Button>
          <Button variant="outline" size="sm" onClick={() => onExport('xlsx')} disabled={exporting} data-testid="export-xlsx-button">
            <Download className="w-4 h-4 mr-1.5" />.xlsx
          </Button>
          {alfrescoConnected && (
            <Button
              variant="outline"
              size="sm"
              onClick={onAlfrescoExport}
              className="text-[#AF2628] border-[#AF2628] hover:bg-[#FFF1F0]"
              data-testid="alfresco-export-button"
            >
              <FolderOpen className="w-4 h-4 mr-1.5" />Alfresco
            </Button>
          )}
          {isAdmin && (
            <Button variant="outline" size="sm" className="text-red-600 hover:text-red-700" onClick={onDelete} data-testid="delete-document-button">
              <Trash2 className="w-4 h-4 mr-1.5" />Excluir
            </Button>
          )}
          {canEdit && (
            <Button variant="outline" size="sm" onClick={onUpload} data-testid="upload-revision-button">
              <Upload className="w-4 h-4 mr-1.5" />Enviar Revisao
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DocumentActions;
